import { JavelinaBaseClient } from './JavelinaBaseClient'

export class JavelinaClientClient extends JavelinaBaseClient {
    constructor(
        javelinaProxyApiUrl = process.env.JAVELINA_PROXY_API_URL, 
        javelinaProxySecretName = process.env.JAVELINA_PROXY_SECRET_NAME || '',
        axiosOptions
    ) {
        super(javelinaProxyApiUrl, javelinaProxySecretName, axiosOptions)
    }

    /**
     * @description returns all clients in javelina
     */
    async getAllClients() {
        await this.createSecureAxiosInstance()

        const response = await this.secureAxiosInstance.get(`pureProxy/core/searchClients/all`);

        if (response.status !== 200) {
            return null;
        }
        
        let results = {
            ...response.data,
            Response: {
                Client: await this.loopPaginationResults("Client", response.data),
            }
        };

        return results;
    }

    /**
     * @description returns all clients for a block of business
     * @param {String} blockOfBusinessId block of business id in JV
     */
    async getAllClientsForBlockOfBusiness(blockOfBusinessId) {
        await this.createSecureAxiosInstance();

        const params = {
            blkOfBusID: blockOfBusinessId
        }

        let path = this.queryParamsToPathParams(params, `pureProxy/core/searchClients`);

        const response = await this.secureAxiosInstance.get(path);

        if (response.status !== 200) {
            return null;
        }
    
        let results = {
            ...response.data,
            Response: {
                Client: await this.loopPaginationResults("Client", response.data),
            }
        };

        return results;
    }

    /**
     * @description returns a client by id and blk of bus
     * @param {String} blockOfBusinessId block of business id in JV
     * @param {String} clientId client id in JV
     */
    async getClient(blockOfBusinessId, clientId) {
        await this.createSecureAxiosInstance();

        const params = {
            blkOfBusID: blockOfBusinessId,
            clientId: clientId
        }

        let path = this.queryParamsToPathParams(params, `pureProxy/core/clients`);

        const response = await this.secureAxiosInstance.get(path);

        if (response.status !== 200) {
            return null;
        }
        return response.data;
    }
}
